import request from '@/utils/request'
const Api = {
    AuthLogin: '/Biz/Auth/login',
    SendLoginValidCode: '/Biz/Auth/sendLoginValidCode',
    LoginByCode: '/Biz/Auth/loginByCode',
    SendRegisterCode: '/Biz/Auth/sendRegisterCode',
    AuthRegister: '/Biz/Auth/register',
    SendForgetCode: '/Biz/Auth/sendForgetCode',
    FindPassword: '/Biz/Auth/findPassword',
    CreateLoginId: '/Biz/Auth/createLoginId',
    LoginIdStatus: '/Biz/Auth/loginIdStatus'
}

/**
 * 生成二维码ID
 * @returns 
 */
export function getLoginIdStatus(params) {
    return request({
        url: Api.LoginIdStatus,
        method: 'get',
        params: params
    })
}


/**
 * 生成二维码ID
 * @returns 
 */
export function getCreateLoginId() {
    return request({
        url: Api.CreateLoginId,
        method: 'get',
    })
}

/**
 * 登录
 * @returns 
 */
export function getAuthLogin(parameter) {
    return request({
        url: Api.AuthLogin,
        method: 'post',
        data: parameter
    })
}

/**
 * 发送登录验证码
 * @returns 
 */
export function getSendLoginValidCode(parameter) {
    return request({
        url: Api.SendLoginValidCode,
        method: 'post',
        data: parameter
    })
}

/**
 * 验证码登录
 * @returns 
 */
export function getLoginByCode(parameter) {
    return request({
        url: Api.LoginByCode,
        method: 'post',
        data: parameter
    })
}

/**
 * 发送注册验证码
 * @returns 
 */
export function getSendRegisterCode(parameter) {
    return request({
        url: Api.SendRegisterCode,
        method: 'post',
        data: parameter
    })
}


/**
 * 注册
 * @returns 
 */
export function getAuthRegister(parameter) {
    return request({
        url: Api.AuthRegister,
        method: 'post',
        data: parameter
    })
}

/**
 * 发送忘记验证码
 * @returns 
 */
export function getSendForgetCode(parameter) {
    return request({
        url: Api.SendForgetCode,
        method: 'post',
        data: parameter
    })
}


/**
 * 忘记密码
 * @returns 
 */
export function getFindPassword(parameter) {
    return request({
        url: Api.FindPassword,
        method: 'post',
        data: parameter
    })
}


// WEBPACK FOOTER //
// ./src/api/login.js